
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./UPPSearch": () => {
return Promise.all(/*  | __federation_expose_UPPSearch */ [__webpack_require__.e(493), __webpack_require__.e(120), __webpack_require__.e(947), __webpack_require__.e(194), __webpack_require__.e(22)]).then(() => (() => (__webpack_require__(76104))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };